export default {
    methods: {
        saveSolution: function saveSolution(path, pos) {
            var name = pos.name,
                image = pos.image,
                priceSoles = pos.priceSoles,
                priceDolares = pos.priceDolares,
                TipoConexion = pos.TipoConexion,
                rental = pos.rental;

            return this.$store.dispatch('affiliation-store/savePos', {
                path: path,
                step: 1,
                data: {
                    pos: name,
                    priceSoles: priceSoles,
                    priceDolares: priceDolares,
                    TipoConexion: TipoConexion,
                    rental: rental,
                    image: image
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/save-solution.js
// module id = ./src/mixins/save-solution.js
// module chunks = 34